define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "./firewallActions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, FirewallActions) {
    "use strict";
    var Firewalls = /** @class */ (function () {
        function Firewalls() {
            this.filterByAny = ko.observable("");
            this.filterByGroup = ko.observable("AllowIP");
            this.canExport = UserContext.hasAccess("Admin,Firewall.Export");
            this.firewallActions = new FirewallActions();
        }
        Firewalls.prototype.init = function () {
            var self = this;
            $("#page-title").text("Firewall");
            tools.ajaxGet({
                url: "/Firewall/GetFirewallLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.firewallsLookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.filterByGroup(self.firewallsLookupLists.DefaultGroup);
                    self.initGrid(self.firewallsLookupLists.GridStructures.FirewallStructure);
                    self.firewallActions.saveCallback = function () {
                        self.firewallTable.refresh();
                    };
                    $(".js-new-ipaddress").on("click", function (event) {
                        self.firewallActions.editIpAddress();
                        event.preventDefault();
                    });
                    $(".js-sync").on("click", function (event) {
                        $(".js-sync").button("loading");
                        self.firewallActions.syncGroup(self.filterByGroup(), function (result) {
                            if (result.Success) {
                                self.firewallTable.refresh();
                            }
                            $(".js-sync").button("reset");
                        });
                        event.preventDefault();
                    });
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        Firewalls.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "130px",
                template: function (dataItem) {
                    var html = "";
                    if (UserContext.hasAccess("Admin,Firewall.Edit,Firewall.Delete")) {
                        html += '<a class="btn btn-sm btn-yellow btn-edit" ><i class="fa fa-edit "></i>&nbsp;Edit</a>';
                    }
                    if (UserContext.hasAccess("Admin,Firewall.Delete")) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.firewallTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Firewall/GetIpAddressess",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.ipGroup = self.filterByGroup();
                                if (self.multipleCustomerSelector) {
                                    data.customerIds = self.multipleCustomerSelector.value().join();
                                }
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#firewall-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                enableExport: {
                    entityName: "IpAddress",
                    title: "IP Addresses",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true
                },
                gridId: "tblFirewall",
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                showPagerOnTop: false,
                controller: self
            };
            self.firewallTable.initGrid(gridOptions);
            $("#tblFirewall tbody").on("click", ".btn-remove", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.firewallActions.deleteServerConfirm(dataItem.Id, dataItem.IpAddress);
                event.preventDefault();
            }).on("click", ".btn-edit", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.firewallActions.editIpAddress(dataItem.Id, dataItem.IpAddress);
                event.preventDefault();
            });
            self.multipleCustomerSelector = $("#filterByCustomerInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                dataTextField: "Text",
                dataValueField: "Value",
                autoClose: false,
                tagMode: "single",
                dataSource: {
                    transport: {
                        read: {
                            url: "/Customers/GetCustomersLookup",
                            type: "POST",
                            dataType: "json"
                        }
                    },
                    schema: {
                        data: function (response) { return response.Data; },
                        total: "Total"
                    },
                    serverFiltering: true
                },
                dataBound: function () {
                    //$(window).trigger("resize");
                },
                change: function (e) {
                    self.firewallTable.refresh();
                }
            }).data("kendoMultiSelect");
            self.firewallActions.deleteCallback = function () {
                self.firewallTable.getGridData().dataSource.read();
            };
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.firewallTable.getGridData().dataSource.read();
            });
            self.filterByGroup.extend({ rateLimit: 200 }).subscribe(function () {
                self.firewallTable.refresh();
            });
        };
        Firewalls.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
            self.filterByGroup(self.firewallsLookupLists.DefaultGroup);
            self.multipleCustomerSelector.value([]);
            self.multipleCustomerSelector.trigger("change");
        };
        Firewalls.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.firewallTable.exportTo();
            }
        };
        Firewalls.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("IpAddress");
                dataLogs.open("Firewall logs");
                event.preventDefault();
            }
        };
        Firewalls.prototype.initLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("IpAddress");
                dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return Firewalls;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Firewall/Index")) {
            log.log("Initialize Firewalls list");
            $(function () {
                (new Firewalls()).init();
            });
        }
    }, 0);
    return Firewalls;
});
//# sourceMappingURL=firewalls.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/firewall/firewalls.js
// module id = 281
// module chunks = 2